import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../core/interceptor/http-interceptor-config";
import Api from "../core/api/api";

export const getTemplateList = createAsyncThunk(
  "template/getTemplateList",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.template_list}${data}`);
     return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);

    }
  }
);


export const getCategoryList = createAsyncThunk(
  "template/getCategoryList",
  async () => {
   const response = await axiosInstance.get(`${Api.category_list}`);
    return response?.data;
  }
);


export const saveNewTemplate = createAsyncThunk(
  "template/saveNewTemplate",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`${Api.create_template}`, data);
     return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);

    }
  }
);

export const updateTemplate = createAsyncThunk(
  "template/updateTemplate",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.put(`${Api.update_template}`, data);
     return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);

    }
  }
);

export const deleteTemplate = createAsyncThunk(
  "template/deleteTemplate",
  async (templateInternalId: any, thunkAPI) => {
    let data: any = {
      template_internal_id : templateInternalId
    }
    try {
     // Send data as a payload using `data` property
     const response = await axiosInstance.delete(`${Api.delete_template}`, {
      data: { template_internal_id: templateInternalId }
    });
     return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);

    }
  }
);

export const getTemplateDetails = createAsyncThunk(
  "template/getTemplateDetails",
  async (templateInternalId: string, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${Api.template_list}?template_internal_id=${templateInternalId}`
      );
      return response?.data;
  } catch (error: any) {
      
   return thunkAPI.rejectWithValue(error?.response?.data);
  }
}
);

export const getSubTemplateList = createAsyncThunk(
    // "template/getSubTemplateList",
    // async (data: any, thunkAPI) => {
    //   try {
    //     const response = await axiosInstance.get(
    //       `${Api.template_list}${data}`
    //     );
    //     return response?.data;
    "template/getSubTemplateDetails",
    async (templateInternalId: string, thunkAPI) => {
      try {
        const response = await axiosInstance.get(
          `${Api.template_list}${templateInternalId}`
        );
        return response?.data;
    } catch (error: any) {
        
     return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
//already in audit details screen
export const AccessStartEndTime = createAsyncThunk(
  "auth/AccessStartEndTime",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(Api.access_start_end_time);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

//get evaluation type
export const getEvaluationTypeList = createAsyncThunk(
  "template/getEvaluationTypeList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.evaluation_type}`);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
